module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_13.6a36680e.pdf";